import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/dm-sans/opsz.css';
import './src/styles/global.css';

import * as React from 'react';

import { initStoryblok } from './src/storyblok/init';
import { SiteShell } from './src/shell/SiteShell';
import { getLocaleFromPath } from './src/storyblok/locales/getLocaleFromPath';

// Call inside wrapRootElement (instead of at module load) so the SDK's
// component registry is populated in the same module-graph context that
// renders pages on the client. Mirrors gatsby-ssr.js for consistency.
export const wrapRootElement = ({ element }) => {
  initStoryblok();
  return element;
};

// Wrap every page with SiteShell so the global Header and Footer render
// around the page tree. Forward the page's locale data from Gatsby's
// pageContext (populated by createPages for Storyblok-routed pages) so
// the Header's LanguageSelector renders with the correct current locale
// and hreflang alternates. Falls back to the pathname-derived locale and
// an empty `alternates` array for non-Storyblok pages (e.g. /style-guide,
// /header-demo, 404) so the selector hides itself there (R13.1). Mirrors
// gatsby-ssr.js so client hydration matches the SSR-rendered HTML.
export const wrapPageElement = ({ element, props }) => {
  const currentLocale =
    props.pageContext && props.pageContext.lang
      ? props.pageContext.lang
      : getLocaleFromPath(props.location.pathname);
  const alternates = (props.pageContext && props.pageContext.alternates) || [];
  return React.createElement(
    SiteShell,
    { pathname: props.location.pathname, currentLocale, alternates },
    element
  );
};
